// getInfo API
export const getInfoData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/getInfo.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// profile post API
export const profilePost = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/profile.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// profile get API
export const profileGetData = async (axios) => {
  try {
    const { data } = await axios({
      url: "/api/profile.php",
      method: "get",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
// patients get API
export const patientsGetData = async (axios) => {
  try {
    const { data } = await axios({
      url: "/api/patients.php",
      method: "get",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// patients pagination get API
export const patientsPaginationGetData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/patients.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// upload study file
export const uploadStudyFile = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/uploadStudyFile.php",
      method: "post",
      params: {
        ...(paramsName && { [paramsName]: 1 }),
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// study post API
export const studyPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/scheduling.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getEnsodataStudyId = async (axios, params = {}) => {
  try {
    const { data } = await axios({
      url: "/api/getEnsodataStudyId.php",
      method: "get",
      params: {
        ...params, // dynamic params here
      },
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const postEnsodataStudyId = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/getEnsodataStudyId.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const getEnsoGeneratedLinkPhysician = async (axios, payload = {}) => {
  try {
    const { data } = await axios({
      url: "/api/ensoGeneratedLinkPhysician.php",
      method: "post",
      data: payload, // dynamic params here
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// reset password API
export const resetPasswordPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/resetPassword.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// results post API
export const resultsPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/results.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// patients post API
export const patientsPostData = async (
  axios,
  paramsName,
  payload,
  fileCategoryId,
) => {
  try {
    const data = await axios({
      url: "/api/patients.php",
      method: "post",
      params: {
        [paramsName]: 1,
        // fileCategoryId
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// admin post API
export const adminPostData = async (axios, paramsName, payload, practiceId) => {
  try {
    const data = await axios({
      url: "/api/admin.php",
      method: "post",
      params: {
        [paramsName]: 1,
        practiceId,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// admin get API
export const adminsGetData = async (axios, paramsName) => {
  try {
    const params = paramsName ? { [paramsName]: 1 } : {};
    const { data } = await axios({
      url: "/api/admin.php",
      method: "get",
      params,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// dashboard get API
export const dashboardGetData = async (axios) => {
  try {
    const { data } = await axios({
      url: "/api/dashboard.php",
      method: "get",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

//  pulldown API
export const pulldownsPostData = async (
  axios,
  paramsName,
  payload,
  isPatientPortal,
) => {
  try {
    const data = await axios({
      url: "/api/pulldowns.php",
      method: "post",
      params: isPatientPortal
        ? {
            [paramsName]: 1,
            patientPortal: 1,
            payload,
          }
        : {
            [paramsName]: 1,
            ...payload,
          },
      data: isPatientPortal
        ? {
            patientPortal: 1,
          }
        : payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
// pull down with additional params
export const pulldownsPostWithId = async ({ axios, paramsName, groupId }) => {
  try {
    const data = await axios({
      url: "/api/pulldowns.php",
      method: "post",
      params: { [paramsName]: 1, groupId },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
// new survey post API
export const surveyPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/survey.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// new order post API
export const orderPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/order.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// report get api
export const reportsGetData = async (axios, reportName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/reports.php",
      method: "post",
      params: {
        reportName: reportName,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const reportsPostData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/reports.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// getReports API
export const getReports = async (axios) => {
  try {
    const { data } = await axios({
      url: "/api/getReports.php",
      method: "get",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// scheduling post API
export const schedulingPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/scheduling.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// patient-view API
export const patientViewGetData = async (
  axios,
  paramsName,
  patientId,
  orderId,
  studyId,
  dmeOrderId,
  fileCategoriesPulldown,
) => {
  try {
    // console.log("fileCategoriesPulldown=>",fileCategoriesPulldown);
    const { data } = await axios({
      url: "/api/patientView.php",
      method: "get",
      params: orderId
        ? {
            [paramsName]: 1,
            patientId,
            orderId,
            studyId,
            dmeOrderId,
            // fileCategoriesPulldown:1
          }
        : {
            [paramsName]: 1,
            patientId,
            studyId,
            dmeOrderId,
            // fileCategoriesPulldown:1
          },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// patient-view post API
export const patientViewPostData = async (
  axios,
  paramsName,
  payload,
  patientId,
) => {
  try {
    const { data } = await axios({
      url: "/api/patientView.php",
      method: "post",
      params: {
        [paramsName]: 1,
        patientId,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// webForms get API

export const webFormsGetData = async (axios, paramsName, params = {}) => {
  try {
    const { data } = await axios({
      url: "/api/webForms.php",
      method: "get",
      params: paramsName
        ? {
            [paramsName]: 1,
            ...params,
          }
        : {},
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// visits get API

export const visitsGetData = async (axios, patientId, paramsName) => {
  try {
    const { data } = await axios({
      url: "/api/visits.php",
      method: "get",
      params: paramsName
        ? {
            [paramsName]: 1,
            patientId,
          }
        : {
            patientId,
          },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const visitGetNewData = async (
  axios,
  paramsName,
  patientId,
  payload,
) => {
  try {
    const { data } = await axios({
      url: "/api/viewVisit.php",
      method: "get",
      params: {
        [paramsName]: 1,
        patientId,
        ...payload,
      },
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const visitsGetStudyData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/studyInfo.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// post visits

export const visitViewPostData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/viewVisit.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// studies.php API

export const studiesPostData = async (axios, payload, paramsName) => {
  try {
    const { data } = await axios({
      url: "/api/studies.php",
      method: "post",
      params: paramsName && {
        [paramsName]: 1,
        // patientId,
        // studyId
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// contact us API
export const contsctUsPost = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/contact.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// dme order api
export const dmeOrderPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/dmeOrder.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// report post api
export const documentFormData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/documentForms.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// webform post api

// admin post API
export const webformPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/webForms.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

//dashboard column filter api
export const columnFilterData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/filters.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getHeaderData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/header.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getDecryptedData = async (axios, encryptedValue) => {
  try {
    const { data } = await axios({
      url: `/api/decrApi.php?encryptedData=${encryptedValue}`,
      method: "post",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getDashboardData = async (axios, payload, paramsName) => {
  try {
    const { data } = await axios({
      url: `/api/getActionInfo.php`,
      method: "post",
      data: payload,
      params: paramsName && { [paramsName]: 1 },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

//dme order data
export const getDmeDashboardData = async (axios, payload, paramsName) => {
  try {
    const { data } = await axios({
      url: `/api/dmeGetActionInfo.php`,
      method: "post",
      data: payload,
      params: paramsName && { [paramsName]: 1 },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getRefreshPreviligeData = async (axios, payload) => {
  try {
    const { data } = await axios({
      url: `/api/refreshPrivilges.php`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// dme order apis

// study post API
export const dmeStudyPostData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/dmeScheduling.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

//  dme brand pulldown API
export const dmeBrandPulldownData = async (axios, paramsName, payload) => {
  try {
    const data = await axios({
      url: "/api/pulldowns.php",
      method: "post",
      params: { [paramsName]: 1 },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const visitsGetDmeStudyData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: "/api/dmeStudyInfo.php",
      method: "post",
      params: {
        [paramsName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// get switch user data
export const getSwitchUserData = async (axios, id) => {
  try {
    const data = await axios({
      url: `/api/pulldowns.php?switchUser=1&userId=${id}`,
      method: "post",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// switch user login api
export const switchUserLogin = async (axios, payload) => {
  try {
    const data = await axios({
      url: "/api/login.php",
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const logOut = async (axios, payload) => {
  try {
    const data = await axios({
      url: "/api/logOut.php",
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// send security code
export const sendSecurityCode = async (axios, code, payload) => {
  try {
    const { data } = await axios({
      url: `/api/profile.php?securityCode=${code}`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

//setMFA api
export const verifyEmailAndPhone = async (
  axios,
  payload,
  paramName,
  authToken,
) => {
  try {
    const { data } = await axios({
      url: `/api/setupMfa.php?${paramName}=1`,
      method: "post",
      data: payload,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// profilepage api
export const verifyProfileEmailPhone = async (axios, payload, paramName) => {
  try {
    const { data } = await axios({
      url: `/api/profile.php?${paramName}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// configuration api
export const getConfigurationData = async (axios) => {
  try {
    const { data } = await axios({
      url: `/api/configuration.php`,
      method: "get",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const handleAddConfiguration = async (axios, payload, paramName) => {
  try {
    const { data } = await axios({
      url: `/api/configuration.php`,
      method: "post",
      params: {
        [paramName]: 1,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const handleDeleteConfiguration = async (axios, payload) => {
  try {
    const { data } = await axios({
      url: `/api/configuration.php?deleteRecord=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

//stages api for latest and previous visits
export const getStagesData = async (axios, payload) => {
  try {
    const { data } = await axios({
      url: `/api/stages.php`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// card connect api for patient portal
export const paymentForNewCard = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/cardConnectPayment.php?typeOperation=${param}`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getCreditCardData = async (axios, payload) => {
  try {
    const { data } = await axios({
      url: `/api/payments.php`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getCreditCardNumber = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/cardConnectPayment.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const paymentForExistingCard = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/paymentHandler.php?typeOperation=${param}`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// scheduling appointments data

export const getAppointmentData = async (axios, paramsName, payload) => {
  try {
    const { data } = await axios({
      url: `/api/patientAppointments.php`,
      method: "post",
      data: payload,
      params: {
        [paramsName]: 1,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// check order for scheduling
export const checkOrderData = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/studyScheduling.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// get number of beds from locations
export const getBedNumbers = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/techScheduling.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// technician schedule save api
export const saveTechnicianSchedule = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/techScheduling.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// tech availibilty
export const getScheduledAppt = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/techAvailability.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// upload order api
export const getUploadOrderData = async (axios, params, payload) => {
  try {
    const { data } = await axios({
      url: "/api/uploadOrder.php",
      method: "post",
      params, // 👈 query params here
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// get upload url api
export const getUploadUrl = async (axios, param, payload) => {
  try {
    // Use params object for query parameters
    const query = {};
    if (param) query[param] = 1;

    const { data } = await axios.get("/api/getUploadUrl.php", {
      params: { ...query, ...payload }, // merge additional query params
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// hst appointment
export const getHSTApptData = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/hstApptCalendar.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// RT appointment
export const getRTApptData = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/resTherAvailability.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// RT scheduling
export const saveSchedule = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/resTherScheduling.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// Revert stage and status
export const revertStageStatusApi = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/revertStageStatus.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// banner api
export const getBannerApi = async (axios) => {
  try {
    const { data } = await axios({
      url: `/api/banner.php`,
      method: "post",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// check tenant api
export const checkTenantApi = async (axios, payload) => {
  try {
    const { data } = await axios({
      url: `/api/checkTenant.php`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// preScreeningQuestionnaire api
export const saveQuestionnaireList = async (axios, param, payload) => {
  try {
    const { data } = await axios({
      url: `/api/preScreeningQuestionnaire.php?${param}=1`,
      method: "post",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const searchMedication = async (axios, term) => {
  if (!term?.trim()) return [];

  const { data } = await axios.get(
    "https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search",
    {
      params: {
        terms: term,
        sf: "DISPLAY_NAME",
        ef: "STRENGTHS_AND_FORMS",
        maxList: 50,
      },
    },
  );

  // RxTerms response structure
  // [0] total
  // [1] rxterms ids
  // [2] extra fields (ef)
  // [3] display fields (sf)

  const totalCount = data?.[0] || 0;
  const ids = data?.[1] || [];
  const displayNames = data?.[3] || [];
  const strengthsRaw = data?.[2]?.STRENGTHS_AND_FORMS || [];

  const medicationList =
    displayNames.map((nameArr, i) => ({
      id: ids[i], // rxterms id
      name: Array.isArray(nameArr) ? nameArr.join(" ") : nameArr, // ✅ array → string
      strengths: strengthsRaw[i]
        ? strengthsRaw[i].map((s) => s.trim()) // ✅ remove whitespaces
        : [],
    })) || [];

  return {
    totalCount,
    medicationList,
  };
};
